export default __webpack_public_path__ + "static/media/icon_facebook.eda04688.svg";